import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ChoixSupportMessages } from 'src/app/modules/shared/models/component-messages/choix-supports-messages';
import { Diffuseur } from '../../../../../models/diffuseur';
import * as jsonColsChoixDiff from '../../../../../../assets/dynamic/support/tableCols.json';
import { DiffuseurItem } from '../../models/diffuseur.item';
import { TableContent } from '../../../../shared/generic/components/tableau/model/table.content';
import { FormGroup } from '@angular/forms';
import { Endpoints } from '../../../../../models/endpoints';
import { LogService } from '../../../../shared/services/log.service';
import { DepartementMapper } from '../../../../../models/enums/zone-geographique.enum';
import { HttpService } from '../../../../shared/services/http.service';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { Preference } from '../../../preferences-avis-de-pub/model/preference';
import { Constants } from '../../../../shared/generic/models/constants';
import { Subject } from 'rxjs';
import { TypeDiffusionEnum } from '../../../../../models/enums/type-diffusion.enum';
import { SessionService } from '../../../../administration/services/session.service';
import { environment } from '../../../../../../environments/environment';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';

@Component({
  selector: 'app-stepper-choix-support',
  templateUrl: './choix-support.component.html',
  styleUrls: ['./choix-support.component.scss'],
})
export class ChoixSupportComponent implements OnInit, OnDestroy {

  private LOG: LogService = new LogService(ChoixSupportComponent);

  public tableContent: TableContent;
  public diffuseurs: Array<Diffuseur> = [];
  @Input() form: FormGroup;
  @Input() checkedDiffuseurs: Array<number> = [];
  @Input() visibleDiffuseurs: Array<number> = [];

  public choixSupport = new ChoixSupportMessages();

  public typeDiffusion = PreferenceType.DIFFUSEURS;

  isPrefActivated = false;

  diffuseursListIds: Array<number> = [];

  chargeTableau = false;

  private unsubscribe$ = new Subject<void>();

  constructor(private http: HttpService, private session: SessionService, private avisDataTransferService: AvisDataTransferService) {
    this.isPrefActivated = environment.pref === 'true';
  }

  public ngOnInit() {
    this.setTableContent();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  setTableContent(): void {
    const tblCont = new TableContent();
    tblCont.displayedCols = ['develop', 'checkbox', 'zonediffusion', 'diffuseur', 'format', 'action'];
    tblCont.expandedColumn = ['develop', 'checkbox', 'zonediffusion', 'diffuseur', 'format', 'action'];
    tblCont.uniqueKey = 'zonediffusion';
    tblCont.tableCols = jsonColsChoixDiff.table;
    tblCont.tableChildCols = jsonColsChoixDiff.table;
    this.http.get(Endpoints.DIFFUSEUR_FINDALL
      + Endpoints.DIFFUSEUR_SIRET
      + this.session.getUser()?.siret
      + Endpoints.DIFFUSEUR_SERVICE
      + this.session.getUser()?.service).subscribe((data) => {
        const diffuseurs = Object.keys(data).map(index => {
          if (environment.shal_enabled === "false" && (data[index].typeFlux?.toString() === 'SHAL' || data[index].typeFlux?.toString() === 'PRESSE_SPE')) {
            return;
          }
          const diffuseur: Diffuseur = data[index];
          const diffuseurItem: DiffuseurItem = new DiffuseurItem();
          diffuseurItem.id = diffuseur.id.toString();
          if (this.visibleDiffuseurs.indexOf(Number(diffuseurItem.id)) !== -1) {
            diffuseurItem.visible = diffuseur.typeZone?.toString() !== 'NATIONAL' && diffuseur.typeZone?.toString() !== 'EUROPE';
          }
          if (this.diffuseursListIds.includes(Number(diffuseurItem.id))) {
            diffuseurItem.checked = true;
          }
          else {
            diffuseurItem.checked = false;
          }
          diffuseurItem.support = diffuseur.support;
          if (diffuseur.typeZone?.toString() === 'EUROPE') {
            if (this.diffuseursListIds.length === 0) {
              diffuseurItem.checked = true;
            }
            diffuseurItem.zonediffusion = diffuseur.typeZone.toString();
            diffuseurItem.diffuseur = 'JOUE';
            // a changer quand le support sera changer en base
            diffuseurItem.support = 'JOUE';
          } else if (diffuseur.typeZone?.toString() === 'NATIONAL') {
            if (this.diffuseursListIds.length === 0) {
              diffuseurItem.checked = true;
            }
            diffuseurItem.zonediffusion = diffuseur.typeZone.toString();
            diffuseurItem.diffuseur = 'BOAMP';
            this.avisDataTransferService.diffuseurID=diffuseurItem.id;
            // a changer quand le support sera changer en base
            diffuseurItem.support = 'BOAMP';
          } else {
            diffuseurItem.zonediffusion = diffuseur.zoneGeographique.toString();
            diffuseurItem.diffuseur = diffuseur.support;
          }
          if (diffuseur.typeZone === null) {
            diffuseurItem.support = diffuseur.intitule;
            diffuseurItem.zonediffusion = diffuseur.zoneGeographique.toString();
            diffuseur.typeSupport = TypeDiffusionEnum.PRESSE_SPE;
          }
          if (diffuseur.typeSupport == TypeDiffusionEnum[TypeDiffusionEnum.PQR]) {
            diffuseurItem.format = 'SHAL';
          } else {
            diffuseurItem.format = diffuseur.typeSupport + '';
          }
          // setter l'élément JOUE/BOAMP
          if (this.checkedDiffuseurs.indexOf(Number(diffuseurItem.id)) !== -1) {
            diffuseurItem.checked = true;
          }
          if (this.visibleDiffuseurs.length == 0) {
            diffuseurItem.visible = true;
          }
          return diffuseurItem;
        }).filter(data => data);

        let tempTable: DiffuseurItem[] = [];
        const deps = diffuseurs.filter((diff) => {
          return diff.zonediffusion !== 'EUROPE' && diff.zonediffusion !== 'NATIONAL';
        });

        this.sortDiff(deps).forEach((diff2) => {
          if (diff2.zonediffusion.includes('D_')) {
            if (this.isDepartementExistant(tempTable, DepartementMapper.getIntitule(diff2.zonediffusion))) {
              tempTable.forEach((e) => {
                if (e.zonediffusion?.includes(DepartementMapper.getIntitule(diff2.zonediffusion))) {
                  if (e.children.length > 0) {
                    const diffParent = diff2;
                    diffParent.idParent = e.id;
                    diffParent.zonediffusion = DepartementMapper.getIntitule(diff2.zonediffusion);
                    // diff2.idParent = e.id;
                    e.children.push(diffParent);
                  } else {
                    const tempItem: DiffuseurItem = new DiffuseurItem();
                    tempItem.id = e.id + 'p';
                    tempItem.diffuseur = '';
                    tempItem.format = '';
                    tempItem.support = '';
                    tempItem.zonediffusion = DepartementMapper.getIntitule(diff2.zonediffusion);
                    tempItem.develop = true;
                    tempItem.children.push(e);
                    // setter l'élément départemental
                    if (this.visibleDiffuseurs.indexOf(Number(tempItem.id)) !== -1) {
                      tempItem.visible = true;
                    }
                    if (this.checkedDiffuseurs.indexOf(Number(tempItem.id)) !== -1) {
                      tempItem.checked = true;
                    }
                    const diffParent = diff2;
                    diffParent.idParent = e.id + 'p';
                    diffParent.zonediffusion = DepartementMapper.getIntitule(diffParent.zonediffusion);
                    tempItem.children.push(diffParent);
                    tempTable[tempTable.indexOf(e)] = tempItem;
                  }
                }
              });
            } else {

              const diffParent = diff2;
              diffParent.idParent = diff2.id + 'p';
              diffParent.zonediffusion = DepartementMapper.getIntitule(diff2.zonediffusion);
              tempTable.push(diffParent);
            }
          }
          if ( diff2.zonediffusion == 'EMPTY'){
            const diffPs = diff2;
            diffPs.idParent = diff2.id + 'p';
            diffPs.zonediffusion = '';
            diffPs.diffuseur = diff2.support;
            tempTable.push(diffPs);
          }
        });
        // TODO

        tempTable.unshift(
          diffuseurs.find((diff) => {
            return diff.zonediffusion === 'EUROPE';
          })
        );
        tempTable.unshift(
          diffuseurs.find((diff) => {
            return diff.zonediffusion === 'NATIONAL';
          })
        );

        tempTable = tempTable.filter(this.notEmpty);
        tblCont.tableData.next(tempTable);
      },
        error => {
          console.error(error);
        });

    this.tableContent = tblCont;

    this.chargeTableau = true;
  }

  private sortDiff(deps: DiffuseurItem[]) {
    return deps.sort((a, b) => {
      const textA = a.zonediffusion.toUpperCase();
      const textB = b.zonediffusion.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }

  public isDepartementExistant(tab: DiffuseurItem[], dep: string) {
    return !!tab.find((diff) => {
      return diff.zonediffusion.includes(dep.toString());
    });
  }

  public notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
  }

  chargeDonneePreference(preference: Preference) {
    this.diffuseursListIds = [];
    preference.content.values.forEach(e => {
      this.diffuseursListIds.push(+e.value);
    });
    this.setTableContent();

  }

  getActionOnTab(event) {
    this.diffuseursListIds = [];
    Object.keys((event.controls.tableDataCtrlName as FormGroup).controls).forEach(key => {
      const diffFormGrp: any = this.form.get(Constants.TABLE_DATA_CTRL_NAME);
      const diffsCtrl: any = diffFormGrp.controls;
      if (diffsCtrl[key].controls.checked.value && !key.includes('p')) {
        this.diffuseursListIds.push(Number(key));
      }
    });
  }

  getActionOnPresse(presse: Diffuseur): void {
    this.setTableContent();
  }
}
